// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import NoBundlesOrdered from './noBundlesOrdered';
import React from 'react';

function NoBundlesOrderedPage () {

    return (
        <AuthenticatedPage className="atp-page atp-no-bundles-ordered-page">
            <NoBundlesOrdered />
        </AuthenticatedPage>
    );

}
NoBundlesOrderedPage.displayNAme = 'NoBundlesOrderedPage';

export default NoBundlesOrderedPage;
